var _mask, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_56919_46304",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
    fill: "#070038"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 20M40 20M40 20M0 20M20 0M40 20M20 40M0 20M20 40V38C10.0589 38 2 29.9411 2 20H0H-2C-2 32.1503 7.84974 42 20 42V40ZM40 20H38C38 29.9411 29.9411 38 20 38V40V42C32.1503 42 42 32.1503 42 20H40ZM20 0V2C29.9411 2 38 10.0589 38 20H40H42C42 7.84974 32.1503 -2 20 -2V0ZM20 0V-2C7.84974 -2 -2 7.84974 -2 20H0H2C2 10.0589 10.0589 2 20 2V0Z",
    fill: "#00E387",
    mask: "url(#path-1-inside-1_56919_46304)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5143 20.954H22.8923V22.88H22.5143V24.5H20.1023V22.88H17.1143V21.008L19.1483 11.9H22.5143V20.954ZM20.1023 20.954V20L20.4983 15.464H20.3723L19.4183 20.954H20.1023Z",
    fill: "#00E387"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFour);
export default __webpack_public_path__ + "static/media/four.d75d97b240f52286324f2f63b61b15e0.svg";
export { ForwardRef as ReactComponent };